module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x640-b087927552bb2be257ae76ee40f1b776.webp";